import React from 'react';

export const PogSpText = () => {
  return (
    <p>
      Призначений для оповіщування людей, що перебувають у будинку (споруді), про виникнення пожежі , щоб створити умови
      для їх своєчасної евакуації. Оповіщування потрібно виконувати у всіх приміщеннях будинків (споруд) з постійним та
      тимчасовим перебуванням людей, та, за необхідності на прилеглій до будинку території.
    </p>
  );
};
